import {Component, Input} from '@angular/core';
import {FlowDescriptionEndpoint} from "@app/netscope/model/data-models";
import {FlowDescriptionEndpointDescription} from "@app/netscope/model/apps-groups-resolver";

/**
 * Apps group a network rule points to, written as the apps groups page shows it: under the icon of that page, the
 * file holding the group, then the group. It opens the group on that page, in a new tab so that the descriptions
 * being edited here are not left. Whatever is put inside of it (a button to remove the group) comes after the link.
 */
@Component({
  standalone: false,
  selector: 'app-apps-group-ref',
  templateUrl: './apps-group-ref.component.html',
  styleUrl: './apps-group-ref.component.css'
})
export class AppsGroupRefComponent {
  @Input() endpoint: FlowDescriptionEndpoint;
  @Input() description: FlowDescriptionEndpointDescription;

  get link(): string[] {
    return ['/apps-groups', this.endpoint.file, 'edit', this.endpoint.name];
  }

  get title(): string {
    return `${this.description?.title ?? ''}\n\nOpen in the apps groups page (new tab)`;
  }
}
